module.exports = {
    BoxSDK: {
        clientID: "o9b2n4qjphsxrx6060vk9r5ox9zjejxo",
        clientSecret: "DYqHOLJ7qLBrGEwgqtaAAfeIZdUsjE1n",
        enterpriseID: "65809755"
    },
    redirectURL: 'https://treasuryappnode-staging.herokuapp.com/home'
  }